// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/prebuild.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CancelPrebuildRequest, CancelPrebuildResponse, CreatePrebuildLogsTokenRequest, CreatePrebuildLogsTokenResponse, CreatePrebuildRequest, CreatePrebuildResponse, DeletePrebuildRequest, DeletePrebuildResponse, GetPrebuildRequest, GetPrebuildResponse, ListPrebuildsRequest, ListPrebuildsResponse } from "./prebuild_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * PrebuildService manages prebuilds for projects to enable faster environment startup times.
 * Prebuilds create snapshots of environments that can be used to provision new environments quickly.
 *
 * @generated from service gitpod.v1.PrebuildService
 */
export const PrebuildService = {
  typeName: "gitpod.v1.PrebuildService",
  methods: {
    /**
     * Creates a prebuild for a project.
     *
     * Use this method to:
     * - Create on-demand prebuilds for faster environment startup
     * - Trigger prebuilds after repository changes
     * - Generate prebuilds for specific environment classes
     *
     * The prebuild process creates an environment, runs the devcontainer prebuild lifecycle,
     * and creates a snapshot for future environment provisioning.
     *
     * ### Examples
     *
     * - Create basic prebuild:
     *
     *   Creates a prebuild for a project using default settings.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   spec:
     *     timeout: "3600s"  # 60 minutes default
     *   ```
     *
     * - Create prebuild with custom environment class:
     *
     *   Creates a prebuild with a specific environment class and timeout.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   spec:
     *     timeout: "3600s"  # 1 hour
     *   ```
     *
     * @generated from rpc gitpod.v1.PrebuildService.CreatePrebuild
     */
    createPrebuild: {
      name: "CreatePrebuild",
      I: CreatePrebuildRequest,
      O: CreatePrebuildResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.PrebuildService.ListPrebuilds
     */
    listPrebuilds: {
      name: "ListPrebuilds",
      I: ListPrebuildsRequest,
      O: ListPrebuildsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets details about a specific prebuild.
     *
     * Use this method to:
     * - Check prebuild status and progress
     * - Access prebuild logs for debugging
     *
     * ### Examples
     *
     * - Get prebuild details:
     *
     *   Retrieves comprehensive information about a prebuild.
     *
     *   ```yaml
     *   prebuildId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.PrebuildService.GetPrebuild
     */
    getPrebuild: {
      name: "GetPrebuild",
      I: GetPrebuildRequest,
      O: GetPrebuildResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Cancels a running prebuild.
     *
     * Use this method to:
     * - Stop prebuilds that are no longer needed
     * - Free up resources for other operations
     *
     * ### Examples
     *
     * - Cancel prebuild:
     *
     *   Stops a running prebuild and cleans up resources.
     *
     *   ```yaml
     *   prebuildId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.PrebuildService.CancelPrebuild
     */
    cancelPrebuild: {
      name: "CancelPrebuild",
      I: CancelPrebuildRequest,
      O: CancelPrebuildResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a prebuild.
     *
     * Prebuilds are automatically deleted after some time. Use this method to
     * manually delete a prebuild before automatic cleanup, for example to remove
     * a prebuild that should no longer be used.
     *
     * Deletion is processed asynchronously. The prebuild will be marked for deletion
     * and removed from the system in the background.
     *
     * ### Examples
     *
     * - Delete prebuild:
     *
     *   Marks a prebuild for deletion and removes it from the system.
     *
     *   ```yaml
     *   prebuildId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.PrebuildService.DeletePrebuild
     */
    deletePrebuild: {
      name: "DeletePrebuild",
      I: DeletePrebuildRequest,
      O: DeletePrebuildResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a logs access token for a prebuild.
     *
     * Use this method to:
     * - Stream logs from a running prebuild
     * - Access archived logs from completed prebuilds
     *
     * Generated tokens are valid for one hour.
     *
     * ### Examples
     *
     * - Create prebuild logs token:
     *
     *   Generates a token for accessing prebuild logs.
     *
     *   ```yaml
     *   prebuildId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.PrebuildService.CreatePrebuildLogsToken
     */
    createPrebuildLogsToken: {
      name: "CreatePrebuildLogsToken",
      I: CreatePrebuildLogsTokenRequest,
      O: CreatePrebuildLogsTokenResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

